import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LocaleLinks from './LocaleLinks';
import { MAX_COUNTRIES } from './constants';

const generateListItemClassName = (country, countries) =>
  classNames(
    'col',
    'xsmall-16',
    'countries-wrapper__item', {
      'large-8': countries.length > MAX_COUNTRIES,
      'large-16': countries.length <= MAX_COUNTRIES,
      'countries-wrapper__item--offset': country.name === 'International',
    },
  );

const CountriesList = ({ countries, isServedFromLegacySite }) => Array.isArray(countries) && countries.map(country => (
  <li
    key={country.slug}
    className={generateListItemClassName(country, countries)}
  >
    {country.name} <LocaleLinks country={country} isServedFromLegacySite={isServedFromLegacySite} />
  </li>
));

CountriesList.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.object),
};

export default CountriesList;
